import React from 'react'
import { FastField, FieldArray } from 'formik'
import { options } from './options'
import { RequestHeader } from './RequestHeader'
import {
  CustomTextField,
  CustomCheckboxField,
  H4,
  CustomDateListField,
  CustomSelectField,
  Button,
} from '../../components'
import { Space, WrapContainer } from '../../layouts'
import { DataTypeFragment } from './DataTypeFragment'

const checkboxFields = [
  { name: 'isExpression', label: 'Is expression' },
  { name: 'isList', label: 'Is list' },
  { name: 'isSymbolSet', label: 'Is symbol set' },
  { name: 'returnName', label: 'Return name' },
  { name: 'returnCurrency', label: 'Return currency' },
  { name: 'returnNoDates', label: 'Return no dates' },
]

interface IRequestForm {
  index: number
  count: number
  isFormDisabled?: boolean
  removeRequest(index: number): void
}

export const RequestForm = ({
  index,
  count,
  removeRequest,
  isFormDisabled,
}: IRequestForm) => (
  <>
    {count < 2 ? null : (
      <RequestHeader
        index={index}
        count={count}
        removeRequest={removeRequest}
        isFormDisabled={isFormDisabled}
      />
    )}
    <FastField
      name={`requests.${index}.instrument`}
      label="Instrument"
      multiline
      component={CustomTextField}
      disabled={isFormDisabled}
    />
    <Space pl={4} pr={4}>
      <WrapContainer contains={3}>
        {checkboxFields.map(({ name, label }) => (
          <FastField
            key={name}
            name={`requests.${index}.${name}`}
            label={label}
            component={CustomCheckboxField}
            disabled={isFormDisabled}
          />
        ))}
      </WrapContainer>
    </Space>
    <Space mt={4} mb={4}>
      <H4>Data types</H4>
    </Space>
    <FieldArray
      name={`requests.${index}.dataTypes`}
      render={({ form, push, remove }) => {
        const { dataTypes = [] } = form.values.requests[index]
        return (
          <>
            {dataTypes.length > 0 && (
              <Space pb={4}>
                <WrapContainer contains={2}>
                  {dataTypes.map((_, dataTypeIndex) => (
                    <Space
                      pl={dataTypeIndex % 2 === 0 ? 0 : 2}
                      pr={dataTypeIndex % 2 === 0 ? 2 : 0}
                      key={dataTypeIndex}
                    >
                      <DataTypeFragment
                        requestIndex={index}
                        dataTypeIndex={dataTypeIndex}
                        remove={() => {
                          remove(dataTypeIndex)
                        }}
                        isFormDisabled={isFormDisabled}
                      />
                    </Space>
                  ))}
                </WrapContainer>
              </Space>
            )}
            <Space width="48%">
              <Button
                id="add-data-type"
                variant="outlined"
                type="button"
                color="primary"
                fullWidth
                onClick={() => push({ value: '', returnName: false })}
                disabled={isFormDisabled}
              >
                Add data type
              </Button>
            </Space>
          </>
        )
      }}
    />
    <Space mt={4}>
      <WrapContainer contains={2}>
        <Space pr={2}>
          <FastField
            name={`requests.${index}.kind`}
            label="Kind"
            component={CustomSelectField}
            disabled={isFormDisabled}
          >
            {options.kind}
          </FastField>
        </Space>
        <Space pl={2}>
          <FastField
            name={`requests.${index}.frequency`}
            label="Frequency"
            component={CustomSelectField}
            disabled={isFormDisabled}
          >
            {options.frequency}
          </FastField>
        </Space>
        <Space pr={2}>
          <FastField
            name={`requests.${index}.start`}
            label="Start"
            component={CustomDateListField}
            listOptions={options.startEnd}
            disabled={isFormDisabled}
          />
        </Space>
        <Space pl={2}>
          <FastField
            name={`requests.${index}.end`}
            label="End"
            component={CustomDateListField}
            listOptions={options.startEnd}
            disabled={isFormDisabled}
          />
        </Space>
      </WrapContainer>
    </Space>
  </>
)
